import { Card } from "@pages/AdminDashboard/ui/Card";
import { FieldList } from "@pages/AdminDashboard/ui/FieldList";
import { StatusBadge, Tag } from "@pages/AdminDashboard/ui/StatusBadge";
import { AdminUserProfile } from "@types-runway/admin";

import { formatUserProfile } from "./formatUserProfile";

interface UserProfileCardProps {
  profile: AdminUserProfile;
}

// The fixed set of readable fields FIND-E4 names (FIND-E8), the name once as the
// card title (USER-R11, USER-R12).
const UserProfileCard = ({ profile }: UserProfileCardProps) => {
  const [name, ...fields] = formatUserProfile(profile);
  const adminMark = profile.isAdmin ? <Tag>Admin</Tag> : <StatusBadge status="Not an admin" />;

  return (
    <div data-testid="user-profile-card">
      <Card eyebrow="User" title={name.value} aside={adminMark}>
        <FieldList fields={fields} />
      </Card>
    </div>
  );
};

export default UserProfileCard;
